import { useEffect, useState } from "react";

interface CountdownHook {
  timeRemaining: number;
  isRunning: boolean;
  startCountdown: () => void;
  stopCountdown: () => void;
  resetCountdown: () => void;
}

function useCountdown(
  durationInSeconds: number,
  noNegative?: boolean,
): CountdownHook {
  const [timeRemaining, setTimeRemaining] = useState<number>(durationInSeconds);
  const [isRunning, setIsRunning] = useState<boolean>(false);

  useEffect(() => {
    let intervalId: NodeJS.Timeout;

    if (isRunning) {
      intervalId = setInterval(() => {
        setTimeRemaining((prevTime) => {
          const nextTime = prevTime - 1;
          return noNegative && nextTime < 0 ? 0 : nextTime;
        });
      }, 1000);
    }

    return () => clearInterval(intervalId);
  }, [isRunning, noNegative]);

  const startCountdown = () => {
    setIsRunning(true);
  };

  const stopCountdown = () => {
    setIsRunning(false);
  };

  const resetCountdown = () => {
    setTimeRemaining(durationInSeconds);
    setIsRunning(false);
  };

  return {
    timeRemaining,
    isRunning,
    startCountdown,
    stopCountdown,
    resetCountdown,
  };
}

export default useCountdown;
